import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'bb-search-box-page-ui',
    templateUrl: './bb-search-box-page-ui.component.html',
    styles: [],
    standalone: false,
})
export class BbSearchBoxPageUiComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
